(ns measure.reporting-ocp.db.validation
  (:require [clojure.spec.alpha :as spec]
            [clojure.string :as str]
            [common.form.core :as form]
            [common.validators.core :refer [valid-email? valid-timezone?]]
            [measure.reporting-ocp.db.options :refer [allowed-channels
                                                      date-phrase-options]]
            [phrase.alpha :as p]
            [re-frame.core :as rf]))

(def allowed-types
  #{"adset_summary" "vast_adset_summary" "impression_context" "vast_split_tests" "split_tests" "product_store" "custom" "vast_custom"})

(defn field-present?
  [{:keys [content-fields context-fields event-types]}]
  (or (seq content-fields) (seq context-fields) (seq event-types)))

(defn product-field-present?
  [product-fields]
  (and (every? string? product-fields)
       (pos? (count product-fields))))

(defn delivery-valid?
  [{:keys [send-emails? email]}]
  (or (false? send-emails?)
      (pos? (count email))))

(defn valid-emails?
  [emails]
  (every? (fn [email]
            (valid-email? (if (map? email)
                            (:value email)
                            email)))
          emails))

(spec/def ::name
  (spec/and string? (complement str/blank?)))

(spec/def ::adset-channel
  allowed-channels)

(spec/def ::adset-ids
  (spec/and (spec/coll-of pos-int?)
            #(pos-int? (count %))))

(spec/def ::date-range
  (spec/and sequential? #(= (count %) 2)))

(spec/def ::date-phrase
  (set (map :value date-phrase-options)))

(spec/def ::timezone
  valid-timezone?)

(spec/def ::type
  allowed-types)

(spec/def ::product-fields
  product-field-present?)

(spec/def ::email
  valid-emails?)

(def default-spec
  (spec/and (spec/keys :req-un [::name ::adset-channel ::adset-ids ::timezone ::type]
                       :opt-un [::date-range ::date-phrase ::email])
            delivery-valid?))

(def custom-report-spec
  (spec/and (spec/keys :req-un [::name ::adset-channel ::adset-ids ::timezone ::type]
                       :opt-un [::date-range ::date-phrase ::email ::content-fields ::context-fields ::event-types])
            field-present?
            delivery-valid?))

(def product-store-report-spec
  (spec/keys :req-un [::name ::adset-channel ::adset-ids ::timezone ::type ::product-fields]
             :opt-un [::date-range ::date-phrase ::event-types]))

(defmulti value :type)

(defmethod value :default [_]
  default-spec)

(defmethod value "custom" [_]
  custom-report-spec)

(defmethod value "vast_custom" [_]
  custom-report-spec)

(defmethod value "product_store" [_]
  product-store-report-spec)

(spec/def ::value (spec/multi-spec value :type))

(p/defphraser (complement str/blank?)
  [_ problem]
  (let [field (-> problem
                  :path
                  last
                  name
                  (str/replace "-" " "))]
    {:message (str/capitalize (str field " should not be empty"))
     :in (:in problem)
     :problem problem}))

(p/defphraser allowed-channels
  [_ problem]
  {:message "Please select a channel"
   :in (:in problem)
   :problem problem})

(p/defphraser #(pos-int? (count %))
  [_ problem]
  {:message "Please select at least one adset"
   :in (:in problem)
   :problem problem})

(p/defphraser allowed-types
  [_ problem]
  {:message "The report type is not valid"
   :in (:in problem)
   :problem problem})

(p/defphraser field-present?
  [_ problem]
  {:message "Custom reports require at least one content field or context field or metric"
   :in [:fields]
   :problem problem})

(p/defphraser product-field-present?
  [_ problem]
  {:message "Product reports require at least one product field"
   :in (:in problem)
   :problem problem})

(p/defphraser delivery-valid?
  [_ problem]
  {:message "Please enter at least one email recipient"
   :in [:delivery-valid?]
   :problem problem})

(p/defphraser valid-emails?
  [_ problem]
  {:message "Please enter only valid email addresses"
   :in (:in problem)
   :problem problem})

(def validate-form
  (rf/enrich
   (form/get-validate-form-fn :form.report ::value)))
